import { ValidatorFn, Validators } from '@angular/forms';

/**
 * Pattern for alphanumeric strings with spaces and hyphens.
 * Allows: A-Z, a-z, 0-9, spaces, and hyphens.
 * Commonly used for insurance member IDs, group numbers, and policy numbers.
 */
export const ALPHANUMERIC_WITH_SPACE_AND_HYPHEN_PATTERN = /^[A-Za-z0-9\- ]+$/;

/**
 * Validator for alphanumeric strings with spaces and hyphens.
 * Returns a validator function that can be used with Angular forms.
 */
export function alphanumericWithSpaceAndHyphenValidator(): ValidatorFn {
  return Validators.pattern(ALPHANUMERIC_WITH_SPACE_AND_HYPHEN_PATTERN);
}
